import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './../../assets/img/logo2.webp';
import LogoScrolled from './../../assets/img/logo.webp';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLinkClick = (e, to) => {
    if (location.pathname === to) {
      e.preventDefault();
      handleScrollTop();
    }
    if (isOpen) setIsOpen(false);
  };

  return (
    <div>
      <nav
        className={`fixed w-full z-20 mt-10 transition-all duration-300 ${
          isScrolled ? "bg-white shadow-md" : "bg-transparent"
        }`}
      >
        <div className="flex justify-between items-center h-24 mx-10 lg:mx-20">
          <img
            src={isScrolled ? LogoScrolled : Logo}
            alt="Logo"
            className="h-10 lg:h-16 w-auto transition-all duration-300 cursor-pointer"
            onClick={handleScrollTop}
          />

          <ul className="hidden lg:flex items-center space-x-6">
            {[
              { to: "/", label: "Accueil" },
              { to: "/stocktanks", label: "Stock Tanks" },
              { to: "/devis", label: "Devis" }
              // { to: "/faq", label: "F.A.Q" }
            ].map((item, index) => (
              <li key={index}>
                <Link
                  to={item.to}
                  onClick={(e) => handleLinkClick(e, item.to)}
                  className={`relative text-lg font-medium group transition-colors duration-300 ${
                    isScrolled ? "text-[#13455a]" : "text-white"
                  }`}
                >
                  {item.label}
                  <span
                    className={`absolute left-0 bottom-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full ${
                      isScrolled ? "bg-[#13455a]" : "bg-white"
                    }`}
                  ></span>
                </Link>
              </li>
            ))}

            <li>
              <Link
                to="/devis"
                onClick={(e) => handleLinkClick(e, "/devis")}
                className={`relative text-lg font-medium rounded-xl px-5 py-2 border transition-all duration-300 transform hover:scale-105 overflow-hidden ${
                  isScrolled
                    ? "bg-[#005478] border-[#005478] text-white hover:bg-white hover:text-[#005478]"
                    : "bg-transparent border-white text-white hover:bg-white hover:text-[#005478]"
                }`}
              >
                Contactez-nous
              </Link>
            </li>
          </ul>

          <button
            onClick={toggleMenu}
            className={`lg:hidden transition-colors duration-300 ${
              isScrolled ? "text-[#13455a]" : "text-white"
            }`}
          >
            <svg
              className={`w-6 h-6 transform transition-transform duration-300 ${
                isOpen ? "rotate-45" : "rotate-0"
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={
                  isOpen
                    ? "M6 18L18 6M6 6l12 12"
                    : "M4 6h16M4 12h16m-7 6h7"
                }
              />
            </svg>
          </button>
        </div>
      </nav>

      {isOpen && (
        <div className="lg:hidden fixed top-0 left-0 w-full h-full bg-white z-50 flex flex-col items-center justify-center transition-all duration-500">
          <ul className="space-y-6 text-center">
            {[
              { to: "/", label: "Accueil" },
              { to: "/stocktanks", label: "Stock Tanks" },
              { to: "/devis", label: "Devis" }
              //{ to: "/faq", label: "F.A.Q" }
            ].map((item, index) => (
              <li key={index}>
                <Link
                  to={item.to}
                  onClick={(e) => handleLinkClick(e, item.to)}
                  className="text-[#13455a] text-xl"
                >
                  {item.label}
                </Link>
              </li>
            ))}

            <li>
              <Link
                to="/devis"
                onClick={(e) => handleLinkClick(e, "/devis")}
                className="border border-[#13455a] text-[#13455a] rounded-xl px-6 py-2 text-xl hover:bg-[#13455a] hover:text-white transition-all"
              >
                Contactez-nous
              </Link>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Navbar;
